import classNames from 'classnames';
import React from 'react';
import { BrandColorGradientMap } from 'models';
import { intlGet } from 'utils/intlGet';
import styles from './styles.module.scss';

type Props = {
  gradient: BrandColorGradientMap | undefined;
  onClick: () => void;
  dataTestId?: string;
};

const GradientSection: React.FunctionComponent<Props> = (props) => {
  const { gradient, onClick, dataTestId = 'gradientSection' } = props;

  return (
    <div className={styles.gradientSection} data-testid={dataTestId}>
      <button
        className={classNames(styles.gradientButton, { active: !!gradient })}
        onClick={onClick}
        data-testid={`${dataTestId}-button`}
      >
        {intlGet('EditorToolbar.BackgroundColorDropdown', 'GradientTitle')}
      </button>
    </div>
  );
};

export default GradientSection;
